import { Grid } from "@mui/material"
import React from "react"
import ReportFormSectionDivider from "Pages/ReportsAlerts/Reports/@components/FormDrawer/SectionDivider"
import {
	ReportAcrissField,
	ReportCategoriesField,
	ReportFuelPolicyField,
	ReportGenerateSwitch,
	ReportLimitHoursField,
	ReportPrepaidField,
	ReportProvidersExclusionSwitch,
	ReportProvidersField,
	ReportWebSuppliersExclusionSwitch,
	ReportWebSuppliersField
} from "Pages/ReportsAlerts/Reports/@components/FormDrawer/Fields"
import { useSignal } from "@preact/signals-react"
import { reportFormData, selectedReportTypeTab } from "Pages/ReportsAlerts/Reports/@signals"
import { AppAntSwitch } from "@components"
import { REPORT_TYPE_TABS } from "Pages/ReportsAlerts/Reports/@constants"

// children are the rows a report type always shows, whatever the Show switch says (the
// required fields: a hidden field does not validate)
export default function ReportFormDrawerExportFiltersSection({ children }) {

	const {
		filterProviders,
		filterWebSuppliers,
		idFuelPolicyFilter,
		filterIsPrepaid,
		filterCategories,
		filterAcriss,
		hoursLimit,
		generate
	} = reportFormData.peek()

	const showSection = useSignal(!!(filterProviders?.length || filterWebSuppliers?.length || idFuelPolicyFilter || filterIsPrepaid || filterCategories?.length || filterAcriss?.length || !!hoursLimit || generate))
	const isRating = selectedReportTypeTab.value === REPORT_TYPE_TABS.RATING

	return <Grid container spacing={2}>
		<Grid item xs={3} data-tour-id="tour-export-filters">
			<ReportFormSectionDivider title="Filters for Excel export & Generation" icon="sliders"/>
		</Grid>
		<Grid item xs={1}>
			<AppAntSwitch
				checked={showSection.value}
				onChange={e => showSection.value = e.target.checked}
				trueText="Show"
			/>
		</Grid>
		<Grid item xs={8}/>
		{children}
		{showSection.value && <>
			<Grid item xs={1.5}>
				<ReportProvidersExclusionSwitch/>
			</Grid>
			<Grid item xs={3}>
				<ReportProvidersField/>
			</Grid>
			<Grid item xs={1.5}>
				<ReportWebSuppliersExclusionSwitch/>
			</Grid>
			<Grid item xs={3}>
				<ReportWebSuppliersField/>
			</Grid>
			{!isRating && <>
				<Grid item xs={3}>
					<ReportFuelPolicyField/>
				</Grid>
				<Grid item xs={3}>
					<ReportPrepaidField/>
				</Grid>
				<Grid item xs={3}>
					<ReportCategoriesField/>
				</Grid>
				<Grid item xs={3}>
					<ReportAcrissField/>
				</Grid>
				<Grid item xs={1}>
					<ReportLimitHoursField/>
				</Grid>
				<Grid item xs={1}>
					<ReportGenerateSwitch/>
				</Grid>
			</>}
		</>}
	</Grid>
}
